/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

(function () {
  var FORM_ID = 'XGDaf5';
  var SHOP_SYSTEM_URL = '/collections/system-of-renewal';
  var STORAGE_KEY = 'evedia.skinPriority.' + FORM_ID;
  var STYLE_ID = 'evedia-klaviyo-skin-priority-style';

  if (window.__evediaKlaviyoSkinPriorityInitialized || document.getElementById(STYLE_ID)) return;
  window.__evediaKlaviyoSkinPriorityInitialized = true;

  var PRIORITIES = {
    'Wrinkles & Fine Lines': true,
    Texture: true,
    Redness: true,
    'Uneven Tone': true,
    Clarity: true
  };
  var markTimer = null;

  function normalizeLabel(value) {
    return String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function priorityFromText(text) {
    var normalized = normalizeLabel(text);
    return Object.prototype.hasOwnProperty.call(PRIORITIES, normalized) ? normalized : '';
  }

  function isWelcomeRoot(root) {
    if (!root || !root.textContent) return false;
    var text = normalizeLabel(root.textContent);
    return text.indexOf("What's your skin's priority?") !== -1 && text.indexOf('EMAIL MY CODE') !== -1;
  }

  function isEvediaPopupRoot(root) {
    if (!root || !root.textContent) return false;
    var text = normalizeLabel(root.textContent).toUpperCase();
    return isWelcomeRoot(root) || (text.indexOf('SHOP THE SYSTEM') !== -1 && text.indexOf('CHECK YOUR INBOX') !== -1);
  }

  function findWelcomeRoot(node) {
    var el = node && node.nodeType === 1 ? node : node && node.parentElement;

    while (el && el !== document.documentElement && el !== document.body) {
      if (isWelcomeRoot(el)) return el;
      el = el.parentElement;
    }

    var roots = document.querySelectorAll('[class*="klaviyo-form"], [role="dialog"]');
    for (var i = 0; i < roots.length; i += 1) {
      if (isWelcomeRoot(roots[i])) return roots[i];
    }

    return null;
  }

  function findEvediaPopupRoot(node) {
    var el = node && node.nodeType === 1 ? node : node && node.parentElement;

    while (el && el !== document.documentElement && el !== document.body) {
      if (isEvediaPopupRoot(el)) return el;
      el = el.parentElement;
    }

    var roots = document.querySelectorAll('[class*="klaviyo-form"], [role="dialog"]');
    for (var i = 0; i < roots.length; i += 1) {
      if (isEvediaPopupRoot(roots[i])) return roots[i];
    }

    return null;
  }

  function findPriorityControl(target) {
    var el = target && target.nodeType === 1 ? target : target && target.parentElement;

    while (el && el !== document.documentElement && el !== document.body) {
      var label = priorityFromText(el.textContent);
      var isControl = el.matches && el.matches('button, a, [role="button"], [tabindex]');

      if (label && isControl) {
        return { element: el, value: label };
      }

      if (el.matches && (el.matches('[class*="klaviyo-form"]') || el.matches('[role="dialog"]'))) break;
      el = el.parentElement;
    }

    return null;
  }

  function setSelected(value) {
    window.__evediaSkinPriority = value;

    try {
      window.sessionStorage.setItem(STORAGE_KEY, value);
    } catch (error) {
      // Private browsing can block storage; the in-memory value still covers this session.
    }
  }

  function getSelected() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) || window.__evediaSkinPriority || '';
    } catch (error) {
      return window.__evediaSkinPriority || '';
    }
  }

  function getEmail(root) {
    var input = root && root.querySelector('input[type="email"], input[name="$email"], input[name="email"]');
    return input ? normalizeLabel(input.value).toLowerCase() : '';
  }

  function ensureHiddenField(root, value) {
    var form = root && (root.closest('form') || root.querySelector('form'));
    if (!form) return;

    var hidden = form.querySelector('input[data-evedia-skin-priority-input]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'Skin Priority';
      hidden.setAttribute('data-evedia-skin-priority-input', 'true');
      form.appendChild(hidden);
    }

    hidden.value = value || '';
  }

  function queueIdentify(email, value) {
    if (!value) return;

    var profile = {
      'Skin Priority': value,
      'Evedia Popup Skin Priority': value
    };

    if (email) {
      profile.email = email;
      profile.$email = email;
    }

    window._learnq = window._learnq || [];
    if (typeof window._learnq.push === 'function') {
      window._learnq.push(['identify', profile]);
    }

    if (!window.klaviyo) return;

    try {
      if (typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(profile);
      } else if (typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['identify', profile]);
      }
    } catch (error) {}
  }

  function queueTrack(value, email) {
    if (!value) return;

    var props = {
      'Skin Priority': value,
      form_id: FORM_ID,
      form_name: 'welcome10off'
    };

    if (email) props.email = email;

    window._learnq = window._learnq || [];
    if (typeof window._learnq.push === 'function') {
      window._learnq.push(['track', 'Evedia Skin Priority Selected', props]);
    }

    if (!window.klaviyo) return;

    try {
      if (typeof window.klaviyo.track === 'function') {
        window.klaviyo.track('Evedia Skin Priority Selected', props);
      } else if (typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', 'Evedia Skin Priority Selected', props]);
      }
    } catch (error) {}
  }

  function isSubmitClick(target) {
    var el = target && target.nodeType === 1 ? target : target && target.parentElement;

    while (el && el !== document.documentElement && el !== document.body) {
      var isControl = el.matches && el.matches('button, a, [role="button"], [tabindex]');
      if (isControl && normalizeLabel(el.textContent).indexOf('EMAIL MY CODE') !== -1) return true;
      if (el.matches && (el.matches('[class*="klaviyo-form"]') || el.matches('[role="dialog"]'))) break;
      el = el.parentElement;
    }

    return false;
  }

  function isShopSystemClick(target) {
    var el = target && target.nodeType === 1 ? target : target && target.parentElement;

    while (el && el !== document.documentElement && el !== document.body) {
      var isControl = el.matches && el.matches('button, a, [role="button"], [tabindex]');
      if (isControl && normalizeLabel(el.textContent).indexOf('SHOP THE SYSTEM') !== -1) return true;
      if (el.matches && (el.matches('[class*="klaviyo-form"]') || el.matches('[role="dialog"]'))) break;
      el = el.parentElement;
    }

    return false;
  }

  function markButtons(root) {
    if (!root || !isWelcomeRoot(root)) return;

    var selected = getSelected();
    var controls = root.querySelectorAll('button, a, [role="button"], [tabindex]');
    ensureHiddenField(root, selected);

    for (var i = 0; i < controls.length; i += 1) {
      var control = controls[i];
      var value = priorityFromText(control.textContent);
      if (!value) continue;

      var isSelected = value === selected;
      control.setAttribute('data-evedia-skin-priority', value);
      if (control.parentElement) control.parentElement.setAttribute('data-evedia-skin-priority-slot', 'true');
      if (control.parentElement && control.parentElement.parentElement) {
        control.parentElement.parentElement.setAttribute('data-evedia-priority-row', 'true');
      }
      control.classList.toggle('evedia-skin-priority-selected', isSelected);
      control.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    }
  }

  function findKlaviyoForm(root) {
    if (!root) return null;
    if (root.matches && root.matches('form.klaviyo-form')) return root;
    return root.querySelector ? root.querySelector('form.klaviyo-form') : null;
  }

  function markKlaviyoWrappers(form, dialog) {
    var el = form && form.parentElement;
    while (el && el !== dialog && el !== document.body && el !== document.documentElement) {
      el.setAttribute('data-evedia-klaviyo-wrapper', 'true');
      el = el.parentElement;
    }

    if (form && form.parentElement) {
      form.parentElement.setAttribute('data-evedia-klaviyo-shell', 'true');
    }
  }

  function markContentRows(content) {
    if (!content) return;

    var rows = content.children || [];
    for (var i = 0; i < rows.length; i += 1) {
      var row = rows[i];
      if (!row || !row.setAttribute) continue;

      var text = normalizeLabel(row.textContent);
      row.setAttribute('data-evedia-content-row', 'true');

      if (!text) {
        row.setAttribute('data-evedia-spacer-row', 'true');
      } else if (text.indexOf('THE EVEDIA LIST') !== -1) {
        row.setAttribute('data-evedia-eyebrow-row', 'true');
      } else if (text.indexOf('10% off your') !== -1 || text.indexOf("What's your skin's priority?") !== -1) {
        row.setAttribute('data-evedia-copy-row', 'true');
      } else if (row.querySelector('[data-evedia-skin-priority]')) {
        row.setAttribute('data-evedia-priority-row', 'true');
      } else if (text.indexOf('EMAIL MY CODE') !== -1) {
        row.setAttribute('data-evedia-email-row', 'true');
      } else if (text.indexOf('10% off orders') !== -1 || text.indexOf('Maybe later') !== -1) {
        row.setAttribute('data-evedia-legal-row', 'true');
      }
    }
  }

  function markEmailControls(root) {
    if (!root || !root.querySelector) return;

    var input = root.querySelector('input[type="email"], input[name="$email"], input[name="email"]');
    if (input) {
      var emailField = input.closest && input.closest('.klaviyo-emailinput');
      if (emailField) {
        emailField.setAttribute('data-evedia-email-field', 'true');
        if (emailField.parentElement) emailField.parentElement.setAttribute('data-evedia-email-slot', 'true');
        if (emailField.parentElement && emailField.parentElement.parentElement) {
          emailField.parentElement.parentElement.setAttribute('data-evedia-email-row', 'true');
        }
      }
    }

    var controls = root.querySelectorAll('button, a, [role="button"], [tabindex]');
    for (var i = 0; i < controls.length; i += 1) {
      var control = controls[i];
      if (normalizeLabel(control.textContent).indexOf('EMAIL MY CODE') === -1) continue;

      control.setAttribute('data-evedia-submit-button', 'true');
      if (control.parentElement) control.parentElement.setAttribute('data-evedia-submit-slot', 'true');
      if (control.parentElement && control.parentElement.parentElement) {
        control.parentElement.parentElement.setAttribute('data-evedia-email-row', 'true');
      }
    }
  }

  function markPopupLayout(root) {
    if (!root || !isEvediaPopupRoot(root)) return;

    var dialog = root.matches && root.matches('[role="dialog"]') ? root : root.closest && root.closest('[role="dialog"]');
    var form = findKlaviyoForm(root) || (dialog && findKlaviyoForm(dialog));
    if (!dialog || !form) return;

    if (dialog) dialog.setAttribute('data-evedia-klaviyo-dialog', 'true');
    form.setAttribute('data-evedia-klaviyo-form', 'true');
    markKlaviyoWrappers(form, dialog);
    markEmailControls(form);

    /* Success step ("Check your inbox") — Klaviyo ships its blocks with
       desktop pixel widths (60px heading / 0px body / 0px button on a 362px
       card) plus a leftover empty side column ~592px tall stacked on top.
       Tag the step so the mobile CSS can normalize it. */
    var formText = normalizeLabel(form.textContent).toUpperCase();
    var isSuccess = formText.indexOf('CHECK YOUR INBOX') !== -1 && formText.indexOf('EMAIL MY CODE') === -1;
    if (isSuccess) form.setAttribute('data-evedia-success-step', 'true');
    else form.removeAttribute('data-evedia-success-step');

    var controls = form.querySelectorAll('button, a, [role="button"]');
    for (var k = 0; k < controls.length; k += 1) {
      if (normalizeLabel(controls[k].textContent).toUpperCase().indexOf('SHOP THE SYSTEM') !== -1) {
        controls[k].setAttribute('data-evedia-shop-button', 'true');
      }
    }

    var children = form.children || [];
    var content = null;
    for (var i = 0; i < children.length; i += 1) {
      var child = children[i];
      if (!child || !child.setAttribute || child.tagName !== 'DIV') continue;

      var childText = normalizeLabel(child.textContent);
      if (child.querySelector && child.querySelector('img') && !childText) {
        child.setAttribute('data-evedia-klaviyo-side-image', 'true');
      } else if (!childText && (!child.querySelector || !child.querySelector('img, button, input, svg, video'))) {
        /* Truly empty structural column (the removed side-image slot) — it
           stacks as a huge blank block above the content in our column flex. */
        child.setAttribute('data-evedia-empty-col', 'true');
      } else if (!content && childText) {
        content = child;
      }
    }

    if (content) {
      content.setAttribute('data-evedia-klaviyo-content', 'true');
      markContentRows(content);
    }

    if (isSuccess) markSuccessBlocks(form);
  }

  /* Success step: Klaviyo lays each row out as [spacer | content | spacer]
     row-flex with desktop sizes — on a 362px card the content div gets
     flex-shrunk to ~8px (one-word-per-line text, 0px-wide button). Mark the
     real content wrappers vs the empty spacers so CSS can hide the spacers
     and let the content fill the card. */
  function markSuccessBlocks(form) {
    var rows = form.querySelectorAll('[data-evedia-content-row]');
    for (var i = 0; i < rows.length; i += 1) {
      var divs = rows[i].querySelectorAll('div');
      for (var j = 0; j < divs.length; j += 1) {
        var d = divs[j];
        var hasBlock = false;
        for (var c = 0; c < d.children.length; c += 1) {
          var tag = d.children[c].tagName;
          if (tag === 'H1' || tag === 'H2' || tag === 'H3' || tag === 'P' || tag === 'BUTTON' || tag === 'A' || tag === 'IMG') { hasBlock = true; break; }
        }
        if (hasBlock) {
          d.setAttribute('data-evedia-success-block', 'true');
        } else if (d.children.length === 0 && !normalizeLabel(d.textContent)) {
          d.setAttribute('data-evedia-success-spacer', 'true');
        }
      }
    }
  }

  function markAll() {
    var roots = document.querySelectorAll('[class*="klaviyo-form"], [role="dialog"]');
    for (var i = 0; i < roots.length; i += 1) {
      markButtons(roots[i]);
      markPopupLayout(roots[i]);
    }
  }

  function scheduleMarkAll() {
    if (markTimer) return;
    markTimer = window.setTimeout(function () {
      markTimer = null;
      markAll();
    }, 50);
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '[data-evedia-skin-priority] {',
      '  cursor: pointer !important;',
      '  transition: background-color .16s ease, border-color .16s ease, color .16s ease, box-shadow .16s ease !important;',
      '}',
      '[data-evedia-skin-priority].evedia-skin-priority-selected,',
      '[data-evedia-skin-priority][aria-pressed="true"] {',
      '  background-color: #5c1f22 !important;',
      '  border-color: #5c1f22 !important;',
      '  color: #fbf3ec !important;',
      '}',
      '[data-evedia-skin-priority].evedia-skin-priority-selected *,',
      '[data-evedia-skin-priority][aria-pressed="true"] * {',
      '  color: #fbf3ec !important;',
      '}',
      '@media (max-width: 640px) {',
      '  [data-evedia-klaviyo-dialog] {',
      '    align-items: flex-start !important;',
      '    box-sizing: border-box !important;',
      '    justify-content: center !important;',
      '    overflow-x: hidden !important;',
      '    overflow-y: auto !important;',
      '    overscroll-behavior: contain !important;',
      '    padding: 18px 14px 22px !important;',
      '    -webkit-overflow-scrolling: touch !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-klaviyo-wrapper] {',
      /* margin:auto (NOT align-self:center) = safe centering: centers when the
         card fits, collapses to 0 when it overflows so the TOP stays reachable
         and the dialog can scroll. align-self:center made the top unreachable. */
      '    align-self: flex-start !important;',
      '    box-sizing: border-box !important;',
      '    flex: 0 0 auto !important;',
      '    height: auto !important;',
      '    margin: auto !important;',
      '    max-height: none !important;',
      '    max-width: 362px !important;',
      '    min-height: 0 !important;',
      '    min-width: 0 !important;',
      '    transform: none !important;',
      '    width: 100% !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-klaviyo-shell] {',
      '    border-radius: 18px !important;',
      '    box-shadow: rgba(26, 10, 10, .24) 0 18px 42px !important;',
      '    overflow: hidden !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-klaviyo-form] {',
      /* The card itself scrolls when taller than the phone (overflow:hidden was
         swallowing the email field on short viewports → signup impossible). */
      '    border-radius: 18px !important;',
      '    box-sizing: border-box !important;',
      '    display: flex !important;',
      '    flex-direction: column !important;',
      '    height: auto !important;',
      '    max-height: 88dvh !important;',
      '    max-width: 362px !important;',
      '    min-height: 0 !important;',
      '    min-width: 0 !important;',
      '    overflow-x: hidden !important;',
      '    overflow-y: auto !important;',
      '    -webkit-overflow-scrolling: touch !important;',
      '    overscroll-behavior: contain !important;',
      '    width: 100% !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-klaviyo-side-image] {',
      '    display: none !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-klaviyo-content] {',
      /* flex:none — the form is a column flexbox; without it the content
         COMPRESSES to fit the capped card instead of overflowing into scroll. */
      '    box-sizing: border-box !important;',
      '    flex: 0 0 auto !important;',
      '    height: auto !important;',
      '    justify-content: flex-start !important;',
      '    min-height: 0 !important;',
      '    width: 100% !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-content-row] {',
      '    box-sizing: border-box !important;',
      '    flex: 0 0 auto !important;',
      '    height: auto !important;',
      '    min-height: 0 !important;',
      '    position: relative !important;',
      '    width: 100% !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-content-row] > div {',
      '    box-sizing: border-box !important;',
      '    height: auto !important;',
      '    margin: 0 !important;',
      '    max-width: 100% !important;',
      '    min-height: 0 !important;',
      '    width: 100% !important;',
      '  }',
      /* Klaviyo rows ship desktop-fixed heights on INNER wrappers too (this is
         what half-clipped the 3rd pill line and hid the email field). Let every
         structural div inside a row grow with its content; the styled email
         field + submit button keep their designed 54px. */
      '  [data-evedia-klaviyo-dialog] [data-evedia-content-row] div:not([data-evedia-email-field]):not([data-evedia-submit-button]) {',
      '    height: auto !important;',
      '    max-height: none !important;',
      '    min-height: 0 !important;',
      '    overflow: visible !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-spacer-row] {',
      '    display: none !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-eyebrow-row] > div {',
      '    padding: 30px 24px 6px !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-copy-row] > div {',
      '    padding: 0 24px 18px !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-copy-row] h1 {',
      '    font-size: 32px !important;',
      '    line-height: 1.02 !important;',
      '    margin-bottom: 12px !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-copy-row] p {',
      '    font-size: 14px !important;',
      '    line-height: 1.45 !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-copy-row] p:last-child {',
      '    margin-bottom: 0 !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-priority-row] {',
      '    align-items: center !important;',
      '    display: flex !important;',
      '    flex-wrap: wrap !important;',
      '    gap: 10px !important;',
      '    justify-content: flex-start !important;',
      '    padding: 0 24px 10px !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-priority-row] > [data-evedia-skin-priority-slot] {',
      '    flex: 0 0 auto !important;',
      '    height: auto !important;',
      '    margin: 0 !important;',
      '    padding: 0 !important;',
      '    width: auto !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-skin-priority] {',
      '    border-radius: 999px !important;',
      '    border-width: 2px !important;',
      '    font-size: 15px !important;',
      '    height: 44px !important;',
      '    min-height: 44px !important;',
      '    min-width: 0 !important;',
      '    padding: 0 18px !important;',
      '    width: auto !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-skin-priority] * {',
      '    font-size: 15px !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-email-row] {',
      '    align-items: stretch !important;',
      '    display: flex !important;',
      '    flex-direction: column !important;',
      '    gap: 12px !important;',
      '    padding: 16px 24px 14px !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-email-row] > [data-evedia-email-slot],',
      '  [data-evedia-klaviyo-dialog] [data-evedia-email-row] > [data-evedia-submit-slot] {',
      /* Klaviyo ships these slots flex:1 0 0px — the ZERO basis collapses them
         to 0px inside our column row, so the input/button overhang upward over
         the pills (align-self:flex-end) and the email field turns invisible.
         flex-basis:auto sizes them by their content again. */
      '    flex: 0 0 auto !important;',
      '    height: auto !important;',
      '    margin: 0 !important;',
      '    min-height: 0 !important;',
      '    padding: 0 !important;',
      '    width: 100% !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-email-field],',
      '  [data-evedia-klaviyo-dialog] [data-evedia-submit-button] {',
      '    box-sizing: border-box !important;',
      '    height: 54px !important;',
      '    min-height: 54px !important;',
      '    width: 100% !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-submit-button] {',
      '    font-size: 13px !important;',
      '    letter-spacing: .14em !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-legal-row] > div {',
      '    padding: 0 24px 26px !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-legal-row] p {',
      '    font-size: 12px !important;',
      '    line-height: 1.45 !important;',
      '  }',
      /* — Success step ("Check your inbox") normalization — */
      '  [data-evedia-klaviyo-dialog] [data-evedia-empty-col] {',
      '    display: none !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-success-step] [data-evedia-content-row] {',
      '    padding-left: 26px !important;',
      '    padding-right: 26px !important;',
      '  }',
      /* Klaviyo step-2 wrappers keep DESKTOP side paddings (~150px/side) — on
         the 362px card that leaves an 8px content box, so width:100% resolved
         to 8px (one-word-per-line text, 0px button). Zero the horizontal
         padding on structural divs; the row's own 26px side padding is the
         margin. Vertical rhythm untouched. */
      '  [data-evedia-klaviyo-dialog] [data-evedia-success-step] [data-evedia-content-row] div {',
      '    margin-left: 0 !important;',
      '    margin-right: 0 !important;',
      '    max-width: 100% !important;',
      '    padding-left: 0 !important;',
      '    padding-right: 0 !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-success-step] [data-evedia-success-spacer] {',
      '    display: none !important;',
      '    flex: 0 0 0px !important;',
      '    width: 0 !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-success-step] [data-evedia-success-block] {',
      '    flex: 1 1 auto !important;',
      '    width: 100% !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-success-step] [data-evedia-content-row] button {',
      '    display: block !important;',
      '    margin-left: auto !important;',
      '    margin-right: auto !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] [data-evedia-success-step] [data-evedia-shop-button] {',
      '    min-height: 52px !important;',
      '    width: 100% !important;',
      '  }',
      '  [data-evedia-klaviyo-dialog] .klaviyo-close-form {',
      '    height: 36px !important;',
      '    margin: 0 !important;',
      '    right: 10px !important;',
      '    top: 10px !important;',
      '    width: 36px !important;',
      '  }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function isMobileOverlayDismissAttempt(target, popupRoot) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 640px)').matches) return false;
    if (!popupRoot || !popupRoot.matches || !popupRoot.matches('[role="dialog"]')) return false;

    var form = findKlaviyoForm(popupRoot);
    var shell = form && form.parentElement;
    return !!(shell && !shell.contains(target));
  }

  function stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  /* Like stopEvent but WITHOUT preventDefault: preventing default on touchstart
     kills the native scroll gesture (iOS), which made the popup unscrollable.
     Stopping propagation alone still keeps Klaviyo's overlay-tap dismiss from
     firing; the click handler below hard-blocks the actual dismissal. */
  function stopEventSoft(event) {
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  function handleOverlayPointer(event) {
    var popupRoot = findEvediaPopupRoot(event.target);
    if (isMobileOverlayDismissAttempt(event.target, popupRoot)) {
      stopEventSoft(event);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var popupRoot = findEvediaPopupRoot(event.target);
      if (!popupRoot) return;

      if (isMobileOverlayDismissAttempt(event.target, popupRoot)) {
        stopEvent(event);
        return;
      }

      if (isShopSystemClick(event.target)) {
        stopEvent(event);
        window.location.assign(SHOP_SYSTEM_URL);
        return;
      }

      var root = isWelcomeRoot(popupRoot) ? popupRoot : findWelcomeRoot(event.target);
      if (!root) return;

      var selected = findPriorityControl(event.target);
      if (selected) {
        setSelected(selected.value);
        markButtons(root);
        queueTrack(selected.value, getEmail(root));
        window.setTimeout(scheduleMarkAll, 60);
        window.setTimeout(scheduleMarkAll, 250);
        return;
      }

      if (isSubmitClick(event.target)) {
        var value = getSelected();
        var email = getEmail(root);
        ensureHiddenField(root, value);
        queueIdentify(email, value);
        queueTrack(value, email);
      }
    },
    true
  );

  document.addEventListener('pointerdown', handleOverlayPointer, true);
  document.addEventListener('touchstart', handleOverlayPointer, { capture: true, passive: true });

  injectStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markAll);
  } else {
    markAll();
  }

  new MutationObserver(scheduleMarkAll).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
